import { useEffect, type ReactNode } from 'react';

import { captureTrackingParamsFromUrl } from '../utils/adsConversionTrackingUtils';
import { useMetrics } from '../hooks/useMetrics';

/**
 * Captures fbclid/ttclid from the URL on first client mount and persists in localStorage,
 * so tracking params survive navigation and are available at signup and on signup success.
 */
export default function TrackingParamsProvider({ children }: { children: ReactNode }) {
  const metrics = useMetrics(true);

  useEffect(() => {
    const result = captureTrackingParamsFromUrl();
    if (result) {
      metrics.logEvent('TrackingParameterDetected', {
        ...result.detected,
        storeSuccessful: result.storeSuccessful,
      });
    }
  }, []);

  return <>{children}</>;
}
